import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import SimpleBar from 'simplebar-react';

const SideBar = ({ handleToggle, toggled, hovered, setHovered }) => {
    const location = useLocation();
    const [activeLink, setActiveLink] = useState(location.pathname);

    useEffect(() => {
        setActiveLink(location.pathname);
    }, [location]);

    const isActive = (path) => {
        return activeLink === path ? 'active' : '';
    };

    return (
        <>
            <div className="sidebar-wrapper" data-simplebar="true"
                onMouseEnter={() => toggled && setHovered(true)}
                onMouseLeave={() => toggled && setHovered(false)}
            >
                <div className="sidebar-header">
                    <div>
                        <img src="images/logo.png" className="logo-icon logo_dark" alt="logo icon" />
                        <img src="images/logo.png" className="logo-icon logo_light" alt="logo icon" />
                    </div>
                    <div className="toggle-icon ms-auto" onClick={handleToggle}>
                        <i className="bx bx-menu" />
                    </div>
                </div>
                <SimpleBar style={{ maxHeight: "100%" }}>
                    <ul className="metismenu" id="menu">
                        <li className={isActive('/')}>
                            <Link to="/">
                                <div className="parent-icon"><i className="bx bx-home" /></div>
                                <div className="menu-title">Dashboard</div>
                            </Link>
                        </li>
                        <li className={isActive('/referee-management')}>
                            <Link to="/referee-management">
                                <div className="parent-icon"><i className="bx bx-user" /></div>
                                <div className="menu-title">Referee Management</div>
                            </Link>
                        </li>
                        <li className={isActive('/club-management')}>
                            <Link to="/club-management">
                                <div className="parent-icon"><i className="bx bx-group" /></div>
                                <div className="menu-title">Club Management</div>
                            </Link>
                        </li>
                        <li className={isActive('/game-scheduling')}>
                            <Link to="/game-scheduling">
                                <div className="parent-icon"><i className="bx bx-message-square-dots" /></div>
                                <div className="menu-title">game matchmaking</div>
                            </Link>
                        </li>
                        <li className={isActive('/game-management')}>
                            <Link to="/game-management">
                                <div className="parent-icon"><i className="bx bx-baseball" /></div>
                                <div className="menu-title">Games Management</div>
                            </Link>
                        </li>
                        <li className={isActive('/finances')}>
                            <Link to="/finances">
                                <div className="parent-icon"><i className="bx bx-credit-card" /></div>
                                <div className="menu-title">Finances &amp; Payouts</div>
                            </Link>
                        </li>
                        <li className={isActive('/roles-management')}>
                            <Link to="/roles-management">
                                <div className="parent-icon"><i className="bx bx-check-shield" /></div>
                                <div className="menu-title">Roles Management</div>
                            </Link>
                        </li>
                        <li className={isActive('/notifications')}>
                            <Link to="/notifications">
                                <div className="parent-icon"><i className="bx bxs-bell" /></div>
                                <div className="menu-title">Notifications</div>
                            </Link>
                        </li>
                        <li className={isActive('/settings')}>
                            <Link to="/settings">
                                <div className="parent-icon"><i className="bx bx-cog" /></div>
                                <div className="menu-title">Settings</div>
                            </Link>
                        </li>
                        <li className={isActive('/profile')}>
                            <Link to="/profile">
                                <div className="parent-icon"><i className="bx bx-user-circle" /></div>
                                <div className="menu-title">Profile</div>
                            </Link>
                        </li>
                    </ul>
                    <div className="sidebar-logout">
                        <ul>
                            <li>
                                <a href="#" data-bs-toggle="modal" data-bs-target="#logoutModal" className="d-flex align-content-center">
                                    <div className="parent-icon"><i className="bx bx-log-out" /></div>
                                    <div className="menu-title">Logout</div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </SimpleBar>
            </div>
        </>
    )
}

export default SideBar